import { Component, Element, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-card-image-title-text',
  styleUrl: 'card-image-title-text.css',
  shadow: true,
})
export class CardImageTitleText {
  @Element() host: HTMLElement;
  // possible values for the type prop will be:
  // icon-with-bg (default)
  // image-with-hover
  // image-large
  // leadership

  @Prop() type            : string = 'icon-with-bg';
  @Prop() useBgOnImage    : boolean = true;
  @Prop() bgColor         : string;
  @Prop() bgImage         : string;
  @Prop() textAlign       : string  = 'center';
  @Prop() linkedIn        : string;
  @Prop() newTab          : boolean = true;

  align = {
    'center' : 'center',
    'right' : 'flex-end'
  }

  href = '#';

  componentWillLoad() {
    if (this.type == 'image-with-hover') {
      const cta = this.host.querySelector('[slot="cta"]') as HTMLElement;
      const newHREF = cta.getAttribute('href');
      newHREF && (this.href = newHREF);
    }
  }

  render() {
    return (
      <Host class={ this.type } style={{
        textAlign : this.textAlign,
        alignItems : this.align[this.textAlign]
      }}>
        {this.bgImage && (
          this.type !== 'icon-with-bg' ? (
            (this.type == 'image-with-hover') ? (
              <a href={this.href}>
                <div class='image-wrapper' style={{ backgroundImage: this.bgImage && `url(${this.bgImage})` }}></div>
              </a>
            ) :
            <div class='image-wrapper' style={{ backgroundImage: this.bgImage && `url(${this.bgImage})` }}></div>
          ) : (
            <div class={ `image-wrapper ${this.useBgOnImage && 'withBG'}` } style={{
              backgroundColor: this.useBgOnImage === true && this.bgColor }}>
              <img src={ this.bgImage && this.bgImage }/>
            </div>
          )
        )}
        <div class="inline-flex">
          <slot name="title"></slot>
          {
            this.linkedIn && <a href={this.linkedIn} target={ this.newTab === true ? '_blank' : '_self' } class="social-link">
            <svg width="21px" height="24px" class="svg-inline--fa fa-linkedin" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="linkedin" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg="">
              <path fill="#858c91" d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path>
            </svg>
          </a>
          }
        </div>

        <slot name="text"></slot>
        <slot name="cta"></slot>
      </Host>
    );
  }
}
